module.exports = __webpack_public_path__ + "img/icon-edit.ac5bea5f.svg";